import userStore from './stores/UserStore';
import { LoginForm } from './components/ui/LoginForm';
import React from 'react';
import { CustomersScreen, OrdersScreen, OrderDetailsScreen } from "./screens";
import { observer } from 'mobx-react';
import { Button } from 'antd';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { InvoiceScreen } from './screens/invoiceScreen';

const App = observer(() => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <OrdersScreen />,
    },
    {
      path: "customers",
      element:  <CustomersScreen />
    },
    {
      path: "orders/:orderId",
      element:  <OrderDetailsScreen />
    },
    {
      path: "orders/:orderId/invoice",
      element: <InvoiceScreen/>
    }
  ]);

  return userStore.isLoggedIn ? <div className="max-w-md mx-auto min-h-screen bg-gray-50">
    <Button className='float-right mt-4 mr-4' onClick={() => {userStore.removeUserToken()}}>Logout</Button>
    <RouterProvider router={router} />
</div>: <LoginForm />;
});

export default App;